import { createSelector } from 'reselect';

import { ServicesEnum, Store, UserType } from '../types';

const selectUser = (state: Store): UserType | null => state.session.user;

const defaultServices = new Set([
  ServicesEnum.MDR,
  ServicesEnum.MR,
  ServicesEnum.LOGS,
]);

export const memoizedSelectCustomerServices = createSelector(
  [selectUser],
  (user) => {
    if (!user) {
      return defaultServices;
    }

    if (!user.customer?.services) {
      return defaultServices;
    }

    return new Set(user.customer?.services);
  },
);
